import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonFilterComponent } from '../common-filter/common-filter.component';
import { CheckboxFilterComponent } from "../../checkbox-filter/checkbox-filter.component";

@Component({
  standalone: true,
    selector: 'size-filter',
    templateUrl: './size-filter.component.html',
    styleUrls: ['./size-filter.component.scss'],
    imports: [CommonModule, CheckboxFilterComponent]
})
export class SizeFilterComponent extends CommonFilterComponent {


}

